import { createFileRoute } from "@tanstack/react-router";
import { externalRedirect } from "@/lib/routeRedirect";

export const Route = createFileRoute("/sitemap")({
  beforeLoad: externalRedirect("/sitemap.xml"),
});
